import React from 'react'

import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { GROWTHBOOK_TEST_NAMES } from 'root-constants'

import { DiscountOffer } from '../DiscountOffer'
import { FreeMonthOffer } from '../FreeMonthOffer'

export const DiscountOfferWrapper: React.FC = () => {
  const isFreeMonthOfferTest = useFeatureIsOn(
    GROWTHBOOK_TEST_NAMES.AYAHPATH_CANCEL_FREE_MONTH,
  )

  return isFreeMonthOfferTest ? <FreeMonthOffer /> : <DiscountOffer />
}
